<template>
  <slot 
    v-bind="{ addVoucher }"
  />
</template>

<script>
import { createDeepClone, trackECommerceEvent, createGtmItemFromProduct } from '../../gtm'

export default {
  props: {
    currency: String,
  },
  methods: {
    addVoucher(product) {
      const gtmItem = createGtmItemFromProduct(
        createDeepClone(product),
        'order'
      )

      let price = null

      if (this.$formValues['frm-bf-form-price_custom']) {
        price = parseInt(this.$formValues['frm-bf-form-price_custom'])
      } else if (this.$formValues['frm-bf-form-price']) {
        price = parseInt(this.$formValues['frm-bf-form-price'])
      }

      if (price) {
        gtmItem.price = price
      }

      if (!gtmItem.price) {
        return
      }

      trackECommerceEvent(
        [gtmItem],
        this.currency,
        gtmItem.price,
        'add_to_cart', 
      )
    },
  },
}
</script>
